import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";

import {
  EAI_CONSOLE_HOST,
  EAI_CONSOLE_PROTOCOL,
  PRODUCT_NAME_TOOLKIT,
} from "@helpers/constants";

const ButtonWrapper = styled(Button)(({ theme }) => ({
  fontWeight: "normal",
  padding: 0,
  paddingLeft: theme.spacing(0.5),
  borderRadius: 0,
  justifyContent: "left",
  fontSize: theme.spacing(1.75),
  "&:hover": { background: "none", textDecoration: "underline" },
})) as typeof Button; // There's an emotion bug that requires this workaround to cast as typeof Button

const DOCS_DATA_HOME = "pages/using-toolkit/data.html";
const DOCS_JOBS_HOME = "pages/using-toolkit/jobs.html";
const DOCS_NOTEBOOKS_HOME = "pages/use_cases/running_jupyter.html";
const DOCS_ASSISTANT_HOME = ""; // TODO: Fill in URL when the AI Assistant docs are available
const DOCS_PERMISSIONS_HOME = "pages/using-toolkit/permissions.html";

// Define constants for the keys
const JOBS = "JOBS";
const DATA = "DATA";
const NOTEBOOKS = "NOTEBOOKS";
const ASSISTANT = "ASSISTANT";
const PERMISSIONS = "PERMISSIONS";
const ACCESS_REQUESTS = "ACCESS_REQUESTS";

const docsSectionToText = {
  [JOBS]: `Jobs in ${PRODUCT_NAME_TOOLKIT}`,
  [DATA]: `Data resources in ${PRODUCT_NAME_TOOLKIT}`,
  [NOTEBOOKS]: `Running a Jupyter Notebook in ${PRODUCT_NAME_TOOLKIT}`,
  [ASSISTANT]: `AI Assistant in ${PRODUCT_NAME_TOOLKIT}`,
  [PERMISSIONS]: `Permissions in ${PRODUCT_NAME_TOOLKIT}`,
  [ACCESS_REQUESTS]: `Permissions in ${PRODUCT_NAME_TOOLKIT}`,
};

const docsSectionToLink = {
  [JOBS]: DOCS_JOBS_HOME,
  [DATA]: DOCS_DATA_HOME,
  [NOTEBOOKS]: DOCS_NOTEBOOKS_HOME,
  [ASSISTANT]: DOCS_ASSISTANT_HOME,
  [PERMISSIONS]: DOCS_PERMISSIONS_HOME,
  [ACCESS_REQUESTS]: DOCS_PERMISSIONS_HOME,
};

export type DocsSection = keyof typeof docsSectionToText;
function DocsLink({ docsSection }: { docsSection: DocsSection }) {
  const link = docsSectionToLink[docsSection as keyof typeof docsSectionToLink];
  if (!link) {
    return null;
  }

  return (
    <ButtonWrapper
      href={`${EAI_CONSOLE_PROTOCOL}//docs.${EAI_CONSOLE_HOST}/${link}`}
      target="_blank"
      rel="noopener"
      color="primary"
      size="small"
      startIcon={<MenuBookOutlinedIcon />}
    >
      Docs: {docsSectionToText[docsSection]}
    </ButtonWrapper>
  );
}

export { DocsLink };
